<template>
  <div>
   <BidderRegistrationComp />
  </div>
</template>

<script>
import BidderRegistrationComp from '../../../../components/tax/delinquent/juneResale/BidderRegistration/BidderRegistration.vue';

export default {
  name: 'BidderRegistration',
  components: {
    BidderRegistrationComp,
  },
};
</script>
